import {offerCheckApi} from '@daedalus/core/src/offer/services/offerCheckApi'

const middleware = () => next => async action => {
  if (offerCheckApi.endpoints.getOfferCheck.matchFulfilled(action)) {
    const {onSuccess} = action.meta.arg.originalArgs.options

    if (onSuccess) {
      onSuccess({httpRequestId: action.payload.httpRequestId})
    }
  }

  return next(action)
}

export default middleware
